export const UNIT_OPTIONS = [
  { value: "item", label: "item(s)" },
  { value: "ml", label: "ml" },
  { value: "g", label: "g" },
  { value: "kg", label: "kg" },
  { value: "l", label: "l" },
] as const;
